import React from 'react';

const DIARIES = [
  { img: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=800&q=70', loc: '大理 · 3天', title: '风花雪月的大理慢时光', text: '终于来到了心心念念的大理，洱海真的太美了！清晨的日光洒在湖面上，远处的苍山云雾缭绕...', author: '小王', likes: 128, comments: 23 },
  { img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&q=70', loc: '川西 · 7天', title: '稻城亚丁 · 最后的香格里拉', text: '翻过海拔4700米的折多山，当牛奶海出现在眼前，所有的疲惫都值得了。蓝天白云下的雪山圣洁无瑕...', author: '摄影师李', likes: 356, comments: 47 },
  { img: 'https://images.unsplash.com/photo-1492571350019-22de08371fd3?w=800&q=70', loc: '京都 · 5天', title: '红叶季的京都漫步', text: '秋天的京都，漫山红叶如诗如画。在清水寺远眺，时间仿佛静止了。渡月桥下的桂川流水悠然...', author: '旅行者小林', likes: 289, comments: 31 },
  { img: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=70', loc: '巴黎 · 4天', title: '塞纳河畔的浪漫邂逅', text: '黄昏时分漫步塞纳河畔，埃菲尔铁塔在夕阳中闪闪发光。左岸的咖啡香混着河水清新...', author: '游走世界', likes: 512, comments: 68 },
];

const DiariesSection = () => {
  return (
    <section className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center justify-between mb-10" style={{ animation: 'rise .75s ease-out both' }}>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2 cb is">旅行日记</h2>
            <p className="text-sm cm">记录你的下一次感动</p>
          </div>
          <button className="bt btl text-[13px] hidden md:inline-flex">✍️ 写日记</button>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {DIARIES.map((d, i) => (
            <div key={i} className="frost overflow-hidden cursor-pointer" style={{ animation: `rise .75s ease-out ${i * 0.08}s both` }}>
              <div className="aspect-[16/10] relative" style={{ background: 'linear-gradient(135deg, var(--deep), var(--mid))' }}>
                <img src={d.img} alt={d.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" onError={(e) => e.target.style.display = 'none'} />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 40%, rgba(22,37,68,0.8))' }} />
                <div className="absolute bottom-0 left-0 right-0 p-4" style={{ zIndex: 3 }}>
                  <div className="text-[11px] cd mb-0.5">📍 {d.loc}</div>
                  <h3 className="text-base font-bold cb">{d.title}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-[13px] cm mb-3 lc2">{d.text}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full" style={{ background: 'linear-gradient(135deg, var(--glow), var(--mid))' }} />
                    <span className="text-[11px] cd">{d.author}</span>
                  </div>
                  <span className="text-[11px] cd">❤️ {d.likes} 💬 {d.comments}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button className="bgm text-[13px]">加载更多 ↓</button>
        </div>
      </div>
    </section>
  );
};

export default DiariesSection;
